export default "__VITE_ASSET__24940807__"